import { DoorConfiguration } from '../../configurator/DoorConfiguration';
import functionsService from '../../services/Configurator/FunctionsService';

import { Characteristic, ValueDefinition, MapCharacteristicAndValue } from '../../configurator/types';
import store from '@/store/index';
import * as TurOberflacheDekorCharacteristic from '../../configurator/CalculatedCharacteristics/TurOberflacheDekorCharacteristic';
import * as TurFalzOberflacheCharacteristic from '../../configurator/CalculatedCharacteristics/TurFalzOberflacheGBSCharacteristic';
//import * as DoorLeafCharacteristic from '../configurator/CalculatedCharacteristics/DoorLeafCharacteristics';
import * as Schlagleiste from '../../configurator/CalculatedCharacteristics/SchlagleisteCharacteristics';

const getDefaultState = () => {
    return {
        model: {
            modelUnlocked: false,
            characteristics: [],
            modelStatus: {
                active: false,
            },
        },
        doorLeafSurfaceModel: {
            modelUnlocked: false,
            characteristics: [],
            modelStatus: {
                active: false,
            },
        },
    }
}

const state = {
    model: {
        modelUnlocked: false,
        characteristics: [],
        modelStatus: {
            active: false,
        },
    },
    doorLeafSurfaceModel: {
        modelUnlocked: false,
        characteristics: [],
        modelStatus: {
            active: false,
        },
    },
};

const addSingleCharacteristicsFilteredOrDefaults = (s: any) => {
    const doorLeafCharacteristics = s.model.characteristics;
    doorLeafCharacteristics.forEach((char: any) => {
        if (char.values.length === 1) {
            const selectedCharacteristic = MapCharacteristicAndValue(char, char.values[0]);
            const currentDoorConfiguration = store.getters['configuratorModule/getCurrentDoorConfiguration'];
            currentDoorConfiguration.Add(DoorConfiguration.DoorLeafSurface, selectedCharacteristic);
        } else {
            var geter = store.getters['configuratorModule/getRegisteredCharacteristicsValue'];
            const regChar = geter(char.code, DoorConfiguration.DoorLeafSurface);
            const exists = regChar.id === char.id;
            const registeredValue = char.values.filter((x: any) => x.id === regChar.value.id)[0];
            const incorrectValue = typeof registeredValue === 'undefined' ? true : false;
            if (exists === false || incorrectValue === true) {
                const valueItem = char.values[0];
                const selectedCharacteristic2 = MapCharacteristicAndValue(char, valueItem);
                const currentDoorConfiguration = store.getters['configuratorModule/getCurrentDoorConfiguration'];
                currentDoorConfiguration.Add(DoorConfiguration.DoorLeafSurface, selectedCharacteristic2);
            }
        }
    });
};

const addOrReplaceCharacteristic = (returnedCharacteristic: any, s: any) => {
    const characteristic = returnedCharacteristic;
    const modelCharacteristics = s.model.characteristics;

    let filteredCharacteristic: any;
    filteredCharacteristic = modelCharacteristics.filter((item: any) => item.code === characteristic.code);
    if (filteredCharacteristic.length !== 0) {
        if (filteredCharacteristic[0].id === characteristic.id) {
            const characteristicIndex: number = modelCharacteristics.indexOf(filteredCharacteristic[0]);
            modelCharacteristics.splice(characteristicIndex, 1, characteristic);
        }
    } else {
        modelCharacteristics.push(characteristic);
    }
};

const getNrOfValues = (code: string, s: any) => {
    const filteredCharacteristic = s.model.characteristics.filter((characteristic: any) => characteristic.code === code)[0];
    if (typeof filteredCharacteristic !== 'undefined') {

        return filteredCharacteristic.values.length;
    } else {
        return 0;
    }
};

const getCharacteristic = (code: string, s: any) => {
    const model = s.model;
    const filteredCharacteristic = s.model.characteristics.filter((characteristic: any) => characteristic.code === code)[0];

    if (typeof filteredCharacteristic !== 'undefined') {
        return filteredCharacteristic;
    } else {
        return s.defaultCharacteristicObject;
    }
};

const checkValue = (characteristicCode: string, value: string, s: any) => {
    const definedValues = store.getters['configuratorModule/getCurrentDoorConfiguration'].Get(DoorConfiguration.DoorLeafSurface);
    const filteredCharacteristic: any = definedValues.filter((item: any) => item.code === characteristicCode && item.value.value === value)[0];

    if (filteredCharacteristic != null || typeof filteredCharacteristic !== 'undefined') {
        return true;
    }
    return false;
};

const filterOberflacheValue = (number: string, s: any) => {
    const oberflaecheCharacteristicValue = TurOberflacheDekorCharacteristic.getOberflaecheLLTValue();
    if (typeof oberflaecheCharacteristicValue !== 'undefined') {
        return oberflaecheCharacteristicValue;
    }
};

const getters = {
    getDoorLeafSurfaceCharacteristics: (s: any) => s.model.characteristics,
    getOberflacheValue: (s: any) => {
        return (number: string) => filterOberflacheValue(number, s);
    },
    getCharacteristicAndValues: (s: any) => {
        return (characteristicCode: string) => getCharacteristic(characteristicCode, s);
    },
    getNrOfValuesByCharacteristic: (s: any) => {
        return (characteristicCode: string) => getNrOfValues(characteristicCode, s);
    },
    checkRadioValue: (s: any) => {
        return (characteristicCode: string, value: string) => checkValue(characteristicCode, value, s);
    },
};

const actions = {
    setDoorLeafSurfaceCharacteristics(context: any, payload: any) {
        context.commit('updateDoorLeafSurfaceCharacteristics', payload);
    },
    addCharacterisitc(context: any, { characteristic, valueDefinition }: any) {
        const selectedCharacteristic = MapCharacteristicAndValue(characteristic, valueDefinition);
        const configuration = context.rootState.configuratorModule.doorConfiguration;
        configuration.Add(DoorConfiguration.DoorLeafSurface, selectedCharacteristic);
    },
    setSingleCharacteristicsFilteredOrDefaults(context: any) {
        context.commit('updateSingleCharacteristicsFilteredOrDefaults');
    },
    valueAddCharacteristic(context: any, { characteristicValue, value }: any) {
        characteristicValue.values[0].value = value;
        const selectedCharacteristic = MapCharacteristicAndValue(characteristicValue, characteristicValue.values[0]);
        context.rootState.configuratorModule.doorConfiguration.AddNumericCharacteristic(DoorConfiguration.DoorLeafSurface, selectedCharacteristic);
    },
    async setCharacteristicDependencies(context: any, chacrateristicCode: string) {
        var modelDoorLeafSurfaceCharacteristics = context.getters.getDoorLeafSurfaceCharacteristics;

        const anchor: any = modelDoorLeafSurfaceCharacteristics.filter(
            (item: any) => item.code === chacrateristicCode)[0];

        const doorConfiguration = context.rootState.configuratorModule.doorConfiguration;
        const filteredDependencies = doorConfiguration.GetDependenciesByCharacteristic(chacrateristicCode);

        return new Promise(async(resolve, reject) => {
            await functionsService.extractDependencies(anchor.id, filteredDependencies)
                .then((response: any) => {
                    context.commit('updateCharacteristicDependencies', response.data);
                    resolve();
                });
        });
    },
    calculateDoorLeafSurfaceZargeGBS(context: any) {
        const zargeGBSCharacteristicValue = TurFalzOberflacheCharacteristic.getDoorSurfcaseZargeGBSLLTValue();
        if (typeof zargeGBSCharacteristicValue !== 'undefined') {
            context.rootState.configuratorModule.doorConfiguration.UpdateCharacteristicValueObject(DoorConfiguration.DoorLeafSurface, 'KTU_MM_ZARGE_OBERFL_GBS', zargeGBSCharacteristicValue);
        }
    },
    calculateDoorLeafSurfaceZargeBS(context: any) {
        const zargeBSCharacteristicValue = TurFalzOberflacheCharacteristic.getDoorSurfcaseZargeBSLLTValue();
        if (typeof zargeBSCharacteristicValue !== 'undefined') {
            context.rootState.configuratorModule.doorConfiguration.UpdateCharacteristicValueObject(DoorConfiguration.DoorLeafSurface, 'KTU_MM_ZARGE_OBERFL_BS', zargeBSCharacteristicValue);
        }
    },
    calculateDoorLeafSurfaceFalz(context: any) {
        const falzCharacteristicValue = TurFalzOberflacheCharacteristic.getDoorSurfcaseFalzLLTValue();
        if (typeof falzCharacteristicValue !== 'undefined') {
            context.rootState.configuratorModule.doorConfiguration.UpdateCharacteristicValueObject(DoorConfiguration.DoorLeafSurface, 'KTU_MM_FALZ_O_BS', falzCharacteristicValue);
        }
    },
    calculateDoorLeafSurfaceFurnierOpeningSide(context: any) {
        const furnierCharacteristicValue = TurOberflacheDekorCharacteristic.getTurOberflacheFurnierBSLLTValue();
        if (typeof furnierCharacteristicValue !== 'undefined') {
            context.rootState.configuratorModule.doorConfiguration.UpdateCharacteristicValueObject(DoorConfiguration.DoorLeafSurface, 'KTU_MM_TUEROBERFL_F_BS', furnierCharacteristicValue);
        }
    },
    calculateDoorLeafSurfaceFurnierCounterOpeningSide(context: any) {
        const furnierCharacteristicValue = TurOberflacheDekorCharacteristic.getTurOberflacheFurnierGBSLLTValue();
        if (typeof furnierCharacteristicValue !== 'undefined') {
            context.rootState.configuratorModule.doorConfiguration.UpdateCharacteristicValueObject(DoorConfiguration.DoorLeafSurface, 'KTU_MM_TUEROBERFL_F_GBS', furnierCharacteristicValue);
        }
    },
    calculateDoorLeafSurfaceLackierungOpeningSide(context: any) {
        const lackierungCharacteristicValue = TurOberflacheDekorCharacteristic.getTurOberflacheLackierungBSLLTValue();
        if (typeof lackierungCharacteristicValue !== 'undefined') {
            context.rootState.configuratorModule.doorConfiguration.UpdateCharacteristicValueObject(DoorConfiguration.DoorLeafSurface, 'KTU_MM_TUEROBERFL_L_BS', lackierungCharacteristicValue);
        }
    },
    calculateDoorLeafSurfaceLackierungCounterOpeningSide(context: any) {
        const lackierungCharacteristicValue = TurOberflacheDekorCharacteristic.getTurOberflacheLackierungGBSLLTValue();
        if (typeof lackierungCharacteristicValue !== 'undefined') {
            context.rootState.configuratorModule.doorConfiguration.UpdateCharacteristicValueObject(DoorConfiguration.DoorLeafSurface, 'KTU_MM_TUEROBERFL_L_GBS', lackierungCharacteristicValue);
        }
    },
    calculateDoorLeafSurfaceDekorOpeningSide(context: any) {
        const zylinderCharacteristicValue = TurOberflacheDekorCharacteristic.getTurOberflacheDekorBSLLTValue();
        if (typeof zylinderCharacteristicValue !== 'undefined') {
            context.rootState.configuratorModule.doorConfiguration.UpdateCharacteristicValueObject(DoorConfiguration.DoorLeafSurface, 'KTU_MM_TUEROBERFL_BS', zylinderCharacteristicValue);
        }
    },

    calculateDoorLeafSurfaceDekorCounterOpeningSide(context: any) {
        const zylinderCharacteristicValue = TurOberflacheDekorCharacteristic.getTurOberflacheDekorGBSLLTValue();
        if (typeof zylinderCharacteristicValue !== 'undefined') {
            context.rootState.configuratorModule.doorConfiguration.UpdateCharacteristicValueObject(DoorConfiguration.DoorLeafSurface, 'KTU_MM_TUEROBERFL_GBS', zylinderCharacteristicValue);
        }
    },
    // Schlagleiste dependent characteristics
    setSchlagleisteDependantCharacteristicOpeningSide(context: any) {
        const configuration = context.rootState.configuratorModule.doorConfiguration;

        configuration.UpdateCharacteristicValueObject(DoorConfiguration.DoorLeafSurface, 'KTU_MM_SCHL_Q_BS', Schlagleiste.schlagleisteHorizontalOpeningSide());
        configuration.UpdateCharacteristicValueObject(DoorConfiguration.DoorLeafSurface, 'KTU_MM_SCHL_S_BS', Schlagleiste.schlagleisteVerticalOpeningSide());
        configuration.UpdateCharacteristicValueObject(DoorConfiguration.DoorLeafSurface, 'KTU_MM_SCHLAG_O_DF_BS', Schlagleiste.schlagleisteHorizontalDFOpeningSide());
        configuration.UpdateCharacteristicValueObject(DoorConfiguration.DoorLeafSurface, 'KTU_MM_SCHLAG_O_L_BS', Schlagleiste.schlagleisteHorizontalLOpeningSide());
        configuration.UpdateCharacteristicValueObject(DoorConfiguration.DoorLeafSurface, 'KTU_MM_SCHLAG_S_DF_BS', Schlagleiste.schlagleisteVerticalDFOpeningSide());
        configuration.UpdateCharacteristicValueObject(DoorConfiguration.DoorLeafSurface, 'KTU_MM_SCHLAG_S_L_BS', Schlagleiste.schlagleisteVerticalLOpeningSide());
    },
    setSchlagleisteDependantCharacteristicCounterOpeningSide(context: any) {
        const configuration = context.rootState.configuratorModule.doorConfiguration;

        configuration.UpdateCharacteristicValueObject(DoorConfiguration.DoorLeafSurface, 'KTU_MM_SCHL_Q_GBS', Schlagleiste.schlagleisteHorizontalCounterOpeningSide());
        configuration.UpdateCharacteristicValueObject(DoorConfiguration.DoorLeafSurface, 'KTU_MM_SCHL_S_GBS', Schlagleiste.schlagleisteVerticalCounterOpeningSide());
        configuration.UpdateCharacteristicValueObject(DoorConfiguration.DoorLeafSurface, 'KTU_MM_SCHLAG_O_DF_GBS', Schlagleiste.schlagleisteHorizontalDFCounterOpeningSide());
        configuration.UpdateCharacteristicValueObject(DoorConfiguration.DoorLeafSurface, 'KTU_MM_SCHLAG_O_L_GBS', Schlagleiste.schlagleisteHorizontalLCounterOpeningSide());
        configuration.UpdateCharacteristicValueObject(DoorConfiguration.DoorLeafSurface, 'KTU_MM_SCHLAG_S_DF_GBS', Schlagleiste.schlagleisteVerticalDFCounterOpeningSide());
        configuration.UpdateCharacteristicValueObject(DoorConfiguration.DoorLeafSurface, 'KTU_MM_SCHLAG_S_L_GBS', Schlagleiste.schlagleisteVerticalLCounterOpeningSide());
    },
    setSchlagleisteSpecialOpeningSide(context: any) {
        const configuration = context.rootState.configuratorModule.doorConfiguration;

        configuration.UpdateCharacteristicValueObject(DoorConfiguration.DoorLeafSurface, 'KTU_MM_SCHLAG_O_SO_BS', Schlagleiste.schlagleisteSpecialHorizontalOpeningSide());
        configuration.UpdateCharacteristicValueObject(DoorConfiguration.DoorLeafSurface, 'KTU_MM_SCHLAG_S_SO_BS', Schlagleiste.schlagleisteSpecialVerticalOpeningSide());
    },
    setSchlagleisteSpecialCounterOpeningSide(context: any) {
        const configuration = context.rootState.configuratorModule.doorConfiguration;

        configuration.UpdateCharacteristicValueObject(DoorConfiguration.DoorLeafSurface, 'KTU_MM_SCHLAG_O_SO_GBS', Schlagleiste.schlagleisteSpecialHorizontalCounterOpeningSide());
        configuration.UpdateCharacteristicValueObject(DoorConfiguration.DoorLeafSurface, 'KTU_MM_SCHLAG_S_SO_GBS', Schlagleiste.schlagleisteSpecialVerticalCounterOpeningSide());
    },
    setFalzOberflacheCounterOpeningSide(context: any) {
        const configuration = context.rootState.configuratorModule.doorConfiguration;
        var data = TurFalzOberflacheCharacteristic.setTurOberflacheFALZGBSValue();

        configuration.UpdateCharacteristicValueObject(DoorConfiguration.DoorLeafSurface, 'KTU_MM_FALZ_O_GBS', data[0]);
        configuration.UpdateCharacteristicValueObject(DoorConfiguration.DoorLeafSurface, 'KTU_MM_FALZ_GBS', data[1]);
        configuration.UpdateCharacteristicValue(DoorConfiguration.DoorLeafSurface,'KTU_MM_FALZ_O_SO_GBS', data[2]);
    },
    setNormalDichtungCharacteristic(context: any){
        const configuration = context.rootState.configuratorModule.doorConfiguration;
        var data = TurOberflacheDekorCharacteristic.getNormalDichtungValue();

        configuration.UpdateCharacteristicValueObject(DoorConfiguration.DoorLeafSurface, 'KTU_MM_DICHTUNG', data[0]);
        configuration.UpdateCharacteristicValueObject(DoorConfiguration.DoorLeafSurface, 'KTU_MM_RH_DICHTUNG', data[1]);
    },
    setAProfilAndAWinkel(context: any)
    {
        const configuration = context.rootState.configuratorModule.doorConfiguration;
        var data1 = TurOberflacheDekorCharacteristic.getAbschlussprofilOberflache();
        var data2 = TurOberflacheDekorCharacteristic.getAbschlusswinkelOberflache();
        configuration.UpdateCharacteristicValueObject(DoorConfiguration.DoorLeafSurface, 'KTU_MM_ABSCHLUSSPROFIL_O', data1);
        configuration.UpdateCharacteristicValueObject(DoorConfiguration.DoorLeafSurface, 'KTU_MM_ABSCHLUSSWINKEL_O', data2);
    },
    setAProfileSOAndWinkelSO(context: any) {
        const configuration = context.rootState.configuratorModule.doorConfiguration;
        var data1 = TurOberflacheDekorCharacteristic.getAbschlussprofilOberflacheSO();
        var data2 = TurOberflacheDekorCharacteristic.getAbschlusswinkelOberflacheSO();
        configuration.UpdateCharacteristicValueObject(DoorConfiguration.DoorLeafSurface, 'KTU_MM_ABSCHLUSSPROFIL_O_SO', data1);
        configuration.UpdateCharacteristicValueObject(DoorConfiguration.DoorLeafSurface, 'KTU_MM_ABSCHLUSSWINKEL_O_SO', data2);
    },
    setFutterplOberfl(context: any){
        let result = '';
        const configurator = context.rootState.configuratorModule.doorConfiguration;
        const getter = store.getters['configuratorModule/getRegisteredCharacteristicsValue'];
        const data = getter('CUST_MM_ZARGE_OBERFL_GBS_N', DoorConfiguration.DoorLeafSurface).value.value;
        const val = getter('KTU_MM_ZARGE_OBERFL_SOND_GBS', DoorConfiguration.DoorLeafSurface).value.value;
        const futterpl = getter('KTU_MM_FUTTERPL_OBERFL', DoorConfiguration.DoorLeafSurface).value.value;
        // debugger;
        if(parseInt(data) === 12 && futterpl !== '0')
            result = val;
        configurator.UpdateCharacteristicValue(DoorConfiguration.DoorLeafSurface, 'KTU_MM_FUTTERPL_OBERFL_SO', result);
    },
    setStaffelOberfalche(context: any){
        let staffelOberflache = context.getters.getOberflacheValue('KTU_MM_STAFFEL_OBERFLAECHE');
        context.dispatch('addCharacterisitc', { characteristic: context.getters.getCharacteristicAndValues("KTU_MM_STAFFEL_OBERFLAECHE"), valueDefinition: staffelOberflache });
    },
    initDoorLeafSurfaceModule(context : any, payload : any){
        context.commit('initDoorLeafSurfaceModule', payload);
    },
    resetState(context : any)
    {
        context.commit('resetState');
    }
};

const mutations = {
    updateDoorLeafSurfaceCharacteristics(s: any, payload: any) {
        s.model.characteristics = payload.characteristics;
    },
    updateSingleCharacteristicsFilteredOrDefaults(s: any) {
        addSingleCharacteristicsFilteredOrDefaults(s);
    },
    updateCharacteristicDependencies(s: any, payload: any) {
        const characteristic = payload.characteristics[0];
        if (typeof characteristic !== 'undefined') {
            addOrReplaceCharacteristic(characteristic, s);
            addSingleCharacteristicsFilteredOrDefaults(s);
        }
    },
    initDoorLeafSurfaceModule(context : any, payload : any)
    {
        //init doorleafSurfaceModuleHere
    },
    resetState(s: any)
    {
        Object.assign(s, getDefaultState());
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};